<template>
  <ListItem :has-error="hasError">
    <div class="handle cursor-grab">
      <Icon name="bars-3" class="text-black/20" />
    </div>
    <div class="flex basis-1/4 items-center gap-2">
      <span class="text-orange-900/60 text-xs">{{ t('name') }}:</span>{{ template.name }}
    </div>
    <div class="flex basis-3/4 items-center gap-2">
      <span class="text-orange-900/60 text-xs">{{ t('conditions') }}:</span>
      {{
        Object.entries(template.conditions)
          .filter(([_, value]) => value)
          .map(([key]) => t('pricingModifierConditions.' + key))
          .join(', ')
      }}
    </div>
    <DeleteButton class="flex-shrink-0" @click.stop="$emit('delete')" />
  </ListItem>
</template>

<script setup lang="ts">
import type { PricingModifierTemplateDto } from '@carvia/ros-client-types';
import { useI18n } from 'vue-i18n';
import ListItem from '@/views/yield-management/ui/ListItem.vue';
import DeleteButton from '@/views/yield-management/ui/DeleteButton.vue';

defineProps<{
  template: PricingModifierTemplateDto;
  hasError?: boolean;
}>();

defineEmits<{
  (e: 'delete'): void;
}>();

const { t } = useI18n();
</script>

<i18n lang="json">
{
  "en": {
    "name": "Name",
    "conditions": "Conditions"
  },
  "de": {
    "name": "Name",
    "conditions": "Bedingungen"
  },
  "es": {
    "name": "Nombre",
    "conditions": "Condiciones"
  }
}
</i18n>
